import { AxiosInstance } from "axios"
import {
    FetchAcquirerAgreementsResponse,
    FetchBankAccountsResponse,
} from "../../../../supplier/admin/settings/posAcquirer/SupplierAdminPOSApi"
import { WellknownAgreementType } from "../../../../supplier/admin/settings/posAcquirer/SupplierAdminPOSTypes"
import { SwiftMerchant } from "./merchantAccountTypes"

export enum MerchantAccountQuery {
    DETAILS = "merchant-details-for-merchant",
    AGREEMENTS = "agreements-for-merchant",
    BANK_ACCOUNTS = "bank-accounts-for-merchant",
    SWIFT = "swift-for-merchant",
}

export type FetchMerchantSwiftResponse = Readonly<{
    merchants: SwiftMerchant[]
}>

export async function fetchMerchantBankAccountsResult(
    { merchantId }: { merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchBankAccountsResponse> {
    const url = `/merchants/${merchantId}/acquirers/bankAccounts`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

export async function fetchAcquirerAgreementsForMerchant(
    { merchantId }: { merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchAcquirerAgreementsResponse> {
    const url = `/merchants/${merchantId}/acquirers/agreements?type=POS`

    const { data } = await axios.get(url, {
        params: {
            type: WellknownAgreementType.ADYEN_POS,
        },
        signal,
    })

    return data
}

export async function fetchMerchantSwift(
    { merchantId }: { merchantId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantSwiftResponse> {
    const url = `/merchants/${merchantId}/account/merchantAccess`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
